/**
 * @type {import("../utils/object_transform").ObjectTransformConfig}
 */
export const filter_transform_config = {
    final_price: {
        transform: (value, key, config) => {
            if (Array.isArray(value)) {
                config.minPrice = value[0];
                config.maxPrice = value[1];
            }
        }
    },

    interior: { to: 'cr_interior_id' },
    exterior: { to: 'cr_exterior_id' },
    size: { to: 'cr_sizeindex_id' },
    kw_rolls_num: { to: 'cr_rolls_id' },
    kw_product_type: { to: 'cr_product_type_id' },
    kw_material_type: { to: 'cr_material_type_id' },
    kw_material_new: { to: 'cr_material_id' },
    kw_main_color: { to: 'cr_color_id' },
    kw_serie: { to: 'cr_serie_id' },
    pim_brand: { to: 'cr_brand_value' },
    category_ids: { to: 'cr_category_ids' }
};
